import {HiOutlineMail} from 'react-icons/hi'
import {AiFillLinkedin} from 'react-icons/ai'
// import {FaWhatsapp} from 'react-icons/fa'

const data = [
    {id: 1, icon: <HiOutlineMail/>, link: 'mailto:kundanpdl95@gmail.com'},
    {id: 2, icon: <AiFillLinkedin/>, link: 'https://www.linkedin.com/in/kundanpaudel/'},
    // {id: 3, icon: <FaWhatsapp/>, link: 'https://wa.me/+233557097546'}
]


export default data